import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { setTokens, clearTokens, getToken } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=logged
  const [perms, setPerms] = useState([]);
  const [gymInfo, setGymInfo] = useState(null); // {gym, subscription_status}

  const loadContext = useCallback(async () => {
    try {
      const [p, g] = await Promise.all([api.get("/my/permissions"), api.get("/my/gym")]);
      setPerms(p.data.permissions || []);
      setGymInfo(g.data);
    } catch (_) {}
  }, []);

  useEffect(() => {
    if (!getToken()) { setUser(false); return; }
    api.get("/auth/me").then((r) => { setUser(r.data); setPerms(r.data.permissions || []); loadContext(); })
      .catch(() => { clearTokens(); setUser(false); });
  }, [loadContext]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setTokens(data.access_token, data.refresh_token);
    setUser(data);
    await loadContext();
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    clearTokens(); setUser(false); setPerms([]); setGymInfo(null);
  };

  const can = (perm) => perms.includes(perm) || perms.includes("glg") || user?.platform_role === "glg_admin";
  const isGlg = user?.platform_role === "glg_admin";

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, perms, can, gymInfo, isGlg, refreshContext: loadContext }}>
      {children}
    </AuthContext.Provider>
  );
}
